import * as THREE from 'three';

/**
 * Configuration for the training track system
 */
export const TRAINING_TRACK_CONFIG = {
    CHECKPOINT: {
        COLOR: 0x00ff00, // Green
        OPACITY: 0.7,
        HEIGHT: 8, // Wyższe checkpointy
        PULSE_SPEED: 0.004, // Szybsze pulsowanie
        ACTIVE_COLOR: 0x00ffff, // Cyan
        COMPLETED_COLOR: 0x888888, // Gray
        PARTICLE_EFFECT: true, // Dodatkowe efekty cząsteczkowe
        LIGHT_INTENSITY: 2.0, // Intensywność światła
    },
    TARGET: {
        STATIC_COLOR: 0xff0000, // Red
        MOVING_COLOR: 0xff6600, // Orange
        CASCADING_COLOR: 0xff00ff, // Purple
        HEALTH_BAR_HEIGHT: 0.3,
        HEALTH_BAR_WIDTH: 2.0,
        HEALTH_BAR_BACKGROUND: 0x333333,
        EXPLOSION_SCALE: 1.5, // Większe eksplozje
        DESTRUCTION_PARTICLES: 150, // Więcej cząsteczek przy zniszczeniu
    },
    RAMP: {
        COLOR: 0xffff00, // Yellow
        OPACITY: 0.8,
        GLOW_INTENSITY: 0.5, // Efekt świecenia
        TRAIL_EFFECT: true, // Efekt śladu za czołgiem
        CAMERA_EFFECT: 'zoom', // Efekt kamery przy skoku
    },
    FIRE_RING: {
        COLOR: 0xff3300, // Orange-red
        PARTICLE_COUNT: 200, // Więcej cząsteczek
        PARTICLE_SIZE: 0.15, // Większe cząsteczki
        FLAME_HEIGHT: 1.0, // Wyższe płomienie
        LIGHT_INTENSITY: 2.0, // Intensywność światła
        LIGHT_DISTANCE: 15, // Zasięg światła
        FLAME_SPEED: 2.0, // Szybkość animacji płomieni
    },
    BOOSTER: {
        COLOR: 0x0066ff, // Blue
        PARTICLE_COUNT: 100, // Więcej cząsteczek
        PARTICLE_SIZE: 0.08, // Większe cząsteczki
        TRAIL_LENGTH: 15, // Długość śladu
        LIGHT_INTENSITY: 1.5, // Intensywność światła
        CAMERA_EFFECT: 'zoom', // Efekt kamery przy przyspieszeniu
    },
    POWER_UP: {
        ROTATION_SPEED: 0.02, // Szybsza rotacja
        HOVER_HEIGHT: 1.0, // Wyższe unoszenie
        HOVER_SPEED: 0.002, // Szybsze unoszenie
        GLOW_INTENSITY: 0.8, // Intensywność świecenia
        PARTICLE_EFFECT: true, // Efekty cząsteczkowe
        COLORS: {
            SPEED_BOOST: 0x00ffff, // Cyan
            SHIELD: 0x0000ff, // Blue
            RAPID_FIRE: 0xff0000, // Red
            HEALTH_BOOST: 0x00ff00, // Green
        },
    },
    TRACK_MARKER: {
        COLOR: 0xffffff, // White
        OPACITY: 0.8,
        HEIGHT: 0.2, // Wyższe markery
        WIDTH: 2.0, // Szersze markery
        GLOW: true, // Efekt świecenia
        PULSE: true, // Efekt pulsowania
    },
    OBSTACLE: {
        COLOR: 0x888888, // Gray
        DESTRUCTION_PARTICLES: 100, // Cząsteczki przy zniszczeniu
        COLLAPSE_SPEED: 1.5, // Szybkość zawalania się
        DESTRUCTION_SOUND: true, // Dźwięk zniszczenia
    },
    CAMERA_EFFECTS: {
        SHAKE_INTENSITY: 0.5, // Intensywność trzęsienia kamery
        SHAKE_DURATION: 1000, // Czas trzęsienia w ms
        ZOOM_INTENSITY: 0.3, // Intensywność przybliżenia
        ZOOM_DURATION: 1500, // Czas przybliżenia w ms
        TILT_INTENSITY: 0.2, // Intensywność przechylenia
        TILT_DURATION: 1200, // Czas przechylenia w ms
    },
    DYNAMIC_LIGHTING: {
        ENABLED: true, // Włączone dynamiczne oświetlenie
        LIGHT_COUNT: 3, // Liczba świateł
        COLOR_CHANGE_SPEED: 0.1, // Szybkość zmiany kolorów
        MOVEMENT_SPEED: 0.5, // Szybkość ruchu świateł
    },
    PARTICLE_EFFECTS: {
        TRAIL_FADE_SPEED: 0.9, // Szybkość zanikania śladów
        MAX_PARTICLES: 1000, // Maksymalna liczba cząsteczek
        FIRE_INTENSITY: 2.0, // Intensywność ognia
        SMOKE_INTENSITY: 1.5, // Intensywność dymu
    },
    INTERACTION_DISTANCE: 6.0, // Większy dystans interakcji
    SCORE_DISPLAY_TIME: 3000, // Dłuższy czas wyświetlania punktów
    SLOW_MOTION_FACTOR: 0.2, // Silniejszy efekt slow-motion
    SLOW_MOTION_DURATION: 3000, // Dłuższy czas slow-motion
    CASCADE_RADIUS: 10.0, // Większy promień kaskadowych wybuchów
    CASCADE_DAMAGE: 80, // Większe obrażenia kaskadowe
    CINEMATIC_CAMERA: true, // Włączone efekty kamery filmowej
    SOUND_EFFECTS: true, // Włączone efekty dźwiękowe
};